@if (contract().deleted) {
  <app-warn-tips>
    Ce contrat a été supprimé le {{ contract().deletedAt | date: 'medium' }} par
    {{ contract().deletedBy ? (contract().deletedBy | userIdToUserName) : 'Inconnu' }}.
    @if (contract().deletionComment) {
      <span class="deletion-comment">Motif : {{ contract().deletionComment }}</span>
    }
  </app-warn-tips>
}
